export enum RoleResponsibility {
  Staff = 2,
  Project = 3,
  Sales = 4,
}
